import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DashboardPage } from './dashboard';
import { ComponentsModule } from '../../components/components.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
	declarations: [
		DashboardPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(DashboardPage),
		PipesModule,
	],
})
export class DashboardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.module.ts